const HIDE_DELAY = 1000;
const INITIAL_HIDE_DELAY = 1000;

export function initStickyDonateButton() {
  const button = document.querySelector('.sticky_donate_btn');

  if (!button) {
    return;
  }

  let hideTimer;
  let lastScrollAt = 0;
  let isHovered = false;
  let isFocused = false;

  const show = () => button.classList.add('is-visible');

  const scheduleHide = (delay = HIDE_DELAY) => {
    window.clearTimeout(hideTimer);

    if (isHovered || isFocused) {
      return;
    }

    const remainingDelay = Math.max(0, lastScrollAt + delay - Date.now());

    hideTimer = window.setTimeout(() => {
      if (!isHovered && !isFocused) {
        button.classList.remove('is-visible');
      }
    }, remainingDelay);
  };

  window.addEventListener('scroll', () => {
    lastScrollAt = Date.now();
    show();
    scheduleHide();
  }, {passive: true});

  button.addEventListener('pointerenter', () => {
    isHovered = true;
    window.clearTimeout(hideTimer);
    show();
  });

  button.addEventListener('pointerleave', () => {
    isHovered = false;
    scheduleHide();
  });

  button.addEventListener('focusin', () => {
    isFocused = true;
    window.clearTimeout(hideTimer);
    show();
  });

  button.addEventListener('focusout', () => {
    isFocused = false;
    scheduleHide();
  });

  lastScrollAt = Date.now();
  // Ensure the hidden, off-screen position is rendered before starting the entrance transition.
  void button.offsetWidth;
  show();
  scheduleHide(INITIAL_HIDE_DELAY);
}
